import { render } from "./EnablePciPassthrough.vue?vue&type=template&id=0776fae6&scoped=true"
import script from "./EnablePciPassthrough.vue?vue&type=script&lang=js"
export * from "./EnablePciPassthrough.vue?vue&type=script&lang=js"

import "./EnablePciPassthrough.vue?vue&type=style&index=0&id=0776fae6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0776fae6"]])

export default __exports__